import { useTranslation } from "react-i18next";
import { useBookInfContext } from "components/context/bookInfContext";
import { dateFormat, getDurationDate } from "util/commAction";
import i18n from "locales/i18n";
import "./bookdates.scss";

export default function BookingDatesWeb() {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const { dates, dateRange } = useBookInfContext();

  const today = new Date().toLocaleDateString(langCd, {
    month: "long",
    day: "numeric",
    weekday: "long",
  });

  const start = new Date(dateFormat(dates[0]));
  const end = new Date(dateFormat(dates[1]));

  const startDay = start.toLocaleDateString(langCd, {
    // year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  });

  const endDay = end.toLocaleDateString(langCd, {
    month: "long",
    day: "numeric",
    weekday: "long",
  });

  const range = dates.length == 2 ? getDurationDate(dates[0], dates[1]) : "";

  return (
    <>
      <div className="book-dates-web">
        {dates.length < 2 && (
          <h3 className="text-blue-300">{t("bck_ttl_hm_ldg_dt_slt")}</h3>
        )}
        {dates.length === 2 && (
          <>
            <div className="text-center">
              <h6 className="black">{t("sb_ttl_hm_total_day")}</h6>
              <h3 className="text-blue-300">{range}</h3>
            </div>
            <div className="text-center">
              <h6 className="black">{t("sb_ttl_hm_chckIn")}</h6>
              <h3 className="text-blue-300">{dates[0] ? startDay : today}</h3>
            </div>
            <div className="text-center">
              <h6 className="black">{t("sb_ttl_hm_chckOut")}</h6>
              <h3 className="text-blue-300">{dates[1] ? endDay : today}</h3>
            </div>
          </>
        )}
      </div>
    </>
  );
}
